import React, { useMemo } from 'react';

import { IconArrowDown } from '../../../../icons';
import Select from '../../../../components/Select/Select';
import { SortKey } from '../../NewsTable/useGetTableColumns';

interface MobileSortDropdownProps {
    orderBy: SortKey;
    sortOrder: 'asc' | 'desc';
    onChange: (orderBy: SortKey, sortOrder: 'asc' | 'desc') => void;
}

const MobileSortDropdown: React.FC<MobileSortDropdownProps> = ({ orderBy, sortOrder, onChange }) => {
    const optionsMap = useMemo(
        () => ({
            'publishedDate-desc': { orderBy: 'publishedDate' as SortKey, sortOrder: 'desc' as const },
            'publishedDate-asc': { orderBy: 'publishedDate' as SortKey, sortOrder: 'asc' as const },
            'title-asc': { orderBy: 'title' as SortKey, sortOrder: 'asc' as const },
            'title-desc': { orderBy: 'title' as SortKey, sortOrder: 'desc' as const },
            'description-asc': { orderBy: 'description' as SortKey, sortOrder: 'asc' as const },
            'description-desc': { orderBy: 'description' as SortKey, sortOrder: 'desc' as const }
        }),
        []
    );

    const sortOptions = useMemo(
        () => [
            { id: 'publishedDate-desc', title: 'Date (Newest first)' },
            { id: 'publishedDate-asc', title: 'Date (Oldest first)' },
            { id: 'title-asc', title: 'Headline (A-Z)' },
            { id: 'title-desc', title: 'Headline (Z-A)' },
            { id: 'description-asc', title: 'Description (A-Z)' },
            { id: 'description-desc', title: 'Description (Z-A)' }
        ],
        []
    );

    const currentValue = useMemo(() => {
        const key = `${orderBy}-${sortOrder}`;
        return optionsMap[key as keyof typeof optionsMap] ? key : 'publishedDate-desc';
    }, [orderBy, sortOrder, optionsMap]);

    const currentOption = sortOptions.find((option) => option.id === currentValue);

    return (
        <div className="NewsBrowseSection__mobile-sort">
            <Select
                inputButton
                buttonContent={(isOpen: boolean) => (
                    <span className="NewsBrowseSection__button-label">
                        {currentOption?.title || 'Date (Newest first)'}
                        <IconArrowDown
                            style={{
                                transform: isOpen ? 'rotate(180deg)' : undefined,
                                transition: 'transform 0.2s ease',
                                fontSize: '12px'
                            }}
                        />
                    </span>
                )}
                options={sortOptions}
                value={[currentValue]}
                onChange={(ids) => {
                    const selectedId = ids[0];
                    const selectedOption = optionsMap[selectedId as keyof typeof optionsMap];
                    if (selectedOption) {
                        onChange(selectedOption.orderBy, selectedOption.sortOrder);
                    }
                }}
                isSearchable={false}
                autoFocus={false}
                dropdownHeight={250}
                isMultiple={false}
                styles={{ selectDropdown: { width: '100%' } }}
                useBrowseStyles
                preventResetOnSelected
            />
        </div>
    );
};

export default MobileSortDropdown;
